var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11.6 12",
    style: {
      enableBackground: "new 0 0 11.6 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.9,9.3c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1c0,0,0.1-0.1,0.1-0.1C3.8,9.2,3.9,9.3,3.9,9.3z M3.2,9.2 c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0s0-0.1-0.1-0.1C3.2,9.1,3.2,9.2,3.2,9.2z M4.2,9.2c-0.1,0-0.1,0.1-0.1,0.1c0,0,0.1,0.1,0.1,0.1 c0.1,0,0.1-0.1,0.1-0.1C4.3,9.2,4.3,9.2,4.2,9.2z M5.7,0.2C2.5,0.2,0,2.7,0,5.9c0,2.6,1.6,4.8,4,5.6c0.3,0.1,0.4-0.1,0.4-0.3 c0-0.1,0-0.9,0-1.4c0,0-1.6,0.4-2-0.7c0,0-0.3-0.7-0.7-0.9c0,0-0.5-0.4,0-0.4c0,0,0.6,0,0.9,0.6C3.2,9.4,4,9.1,4.4,9 c0.1-0.4,0.2-0.6,0.4-0.8C3.5,8,2.1,7.8,2.1,5.6c0-0.6,0.2-1,0.6-1.4C2.6,4.1,2.4,3.4,2.7,2.6c0.5-0.2,1.6,0.6,1.6,0.6 C4.8,3.1,5.3,3,5.8,3s1,0.1,1.5,0.2c0,0,1.1-0.8,1.6-0.6C9.2,3.4,9,4.1,9,4.2c0.4,0.4,0.6,0.7,0.6,1.4c0,2.3-1.4,2.4-2.7,2.6 c0.2,0.2,0.4,0.5,0.4,1.1c0,0.8,0,1.8,0,2c0,0.2,0.1,0.3,0.4,0.3c2.3-0.8,3.9-3,3.9-5.6C11.6,2.7,9,0.2,5.7,0.2z M2.3,8.3 c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0,0,0-0.1,0-0.1C2.4,8.3,2.3,8.2,2.3,8.3z M2,8.1C2,8.1,2,8.1,2,8.1c0.1,0.1,0.1,0.1,0.2,0.1 c0,0,0-0.1-0.1-0.1C2.1,8.1,2,8.1,2,8.1z M2.8,8.9c0,0,0,0.1,0,0.1c0.1,0.1,0.1,0.1,0.2,0c0,0,0-0.1,0-0.1C2.9,8.9,2.8,8.9,2.8,8.9z  M2.5,8.6c0,0,0,0.1,0,0.1s0.1,0.1,0.1,0.1c0,0,0-0.1,0-0.1C2.6,8.6,2.6,8.5,2.5,8.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.9550eb4b4eb476370190b8f83669ecb3.svg";
export { ForwardRef as ReactComponent };